module.exports = __webpack_public_path__ + "img/cup.d2e90fd8.svg";